import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/** @jsxRuntime classic */
/** @jsx jsx */
/** @jsxfrag */

import { useEffect } from 'react';
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { N200 } from '@atlaskit/theme/colors';
var HeadingStyles = css({
  fontWeight: 700,
  color: "var(--ds-text-subtlest, ".concat(N200, ")"),
  fontSize: '11px',
  marginBottom: "var(--ds-space-050, 4px)",
  textTransform: 'uppercase',
  marginTop: "var(--ds-space-0, 0px)",
  marginLeft: "var(--ds-space-100, 8px)"
});
export var AppRecommendationsSectionHeader = function AppRecommendationsSectionHeader(_ref) {
  var title = _ref.title,
    _ref$noAppsTitle = _ref.noAppsTitle,
    noAppsTitle = _ref$noAppsTitle === void 0 ? 'Discover' : _ref$noAppsTitle,
    headingLevel = _ref.headingLevel,
    actionBus = _ref.actionBus,
    mutate = _ref.mutate;
  var HeadingAs = headingLevel;
  useEffect(function () {
    var unsubscribe = actionBus === null || actionBus === void 0 ? void 0 : actionBus.on('USE_EMPTY_APPS_TITLE', function () {
      mutate(function (currentProps) {
        return _objectSpread(_objectSpread({}, currentProps), {}, {
          title: noAppsTitle
        });
      });
    });
    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionBus]);
  return jsx(HeadingAs, {
    "data-testid": 'discovery-sdk-component--app-recommendation-section-header',
    css: HeadingStyles
  }, title);
};
AppRecommendationsSectionHeader.propTypes = {
  title: PropTypes.string.isRequired,
  noAppsTitle: PropTypes.string,
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6']).isRequired
};